// extracted by mini-css-extract-plugin
export default {"container":"add-service-modal_container__leOeY"};